// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.model-box {
  width: 100%;
  background: #fff;
}
.model-box ion-title {
  background: #fff;
  padding: 0 3px;
  font-size: 16px;
}
.model-box .img-box {
  width: 100%;
  max-height: 120px;
  vertical-align: middle;
  display: table;
}
.model-box .img-box app-img {
  vertical-align: middle;
  display: table-cell;
  width: 100%;
}

.noStyle ion-card {
  margin: 0;
}

.title {
  min-height: 36px;
  max-height: 36px;
  font-weight: bold;
  text-align: center;
  width: 100%;
}

.relative .name-box {
  line-height: 1;
  padding: 2px 0;
}

.name-box {
  text-shadow: 0px 0px 10px #ccc;
  color: black;
}

.toolbar-row {
  display: flex;
  overflow-x: auto;
}
.toolbar-row .toolbar-item {
  flex: 0 0 auto;
  cursor: pointer;
  color: var(--main-button-backgroud);
}
.toolbar-row .toolbar-item + .toolbar-item {
  border-right: solid 1px #ccc;
}
.toolbar-row .toolbar-item:active, .toolbar-row .toolbar-item:hover {
  filter: brightness(80%);
  background: var(--button-a-background);
  color: var(--main-top-text);
}
.toolbar-row::-webkit-scrollbar {
  display: none;
}

.active {
  filter: brightness(80%);
  background: var(--button-a-background);
  color: var(--main-top-text);
}

@media screen and (min-width: 767px) {
  .model-box .img-box {
    width: 100%;
    height: 200px;
    vertical-align: middle;
    display: table;
  }
}
.fields-slider ion-slide {
  height: 40px;
  background: white;
  border-left: 1px solid #ccc;
}
.fields-slider ion-slide:hover {
  filter: brightness(95%);
  cursor: pointer;
}

.models-swiper {
  width: 100%;
  background: #ececec;
  border-bottom: 1px solid #ececec;
}

.model-slide {
  width: auto;
}

.model-card {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  white-space: nowrap;
  transition: background 0.2s;
  font-size: 14px;
  min-height: 40px;
  padding: 0 10px;
  cursor: pointer;
}

.model-card:hover {
  background-color: #f5f5f5;
}

.model-img {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  object-fit: cover;
}

.model-name {
  color: #333;
}`, "",{"version":3,"sources":["webpack://./src/core/components/sliders/model-slider/model-slider.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;AACF;AACE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AACJ;AAEE;EACE,WAAA;EAEA,iBAAA;EACA,sBAAA;EACA,cAAA;AADJ;AAIE;EACE,sBAAA;EACA,mBAAA;EACA,WAAA;AAFJ;;AAOE;EACE,SAAA;AAJJ;;AASA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AANF;;AASA;EACE,cAAA;EAEA,cAAA;AAPF;;AAWA;EACE,8BAAA;EAEA,YAAA;AATF;;AAYA;EACE,aAAA;EACA,gBAAA;AATF;AAWE;EAEE,cAAA;EACA,eAAA;EACA,mCAAA;AAVJ;AAaE;EACE,4BAAA;AAXJ;AAcE;EACE,uBAAA;EACA,sCAAA;EACA,2BAAA;AAZJ;AAqBA;EACE,aAAA;AAnBF;;AAsBA;EACE,uBAAA;EACA,sCAAA;EACA,2BAAA;AAnBF;;AAwDA;EAEI;IACE,WAAA;IACA,aAAA;IAEA,sBAAA;IACA,cAAA;EAvDJ;AACF;AAqEE;EACE,YAAA;EACA,iBAAA;EACA,2BAAA;AAnEJ;AAqEE;EACE,uBAAA;EACA,eAAA;AAnEJ;;AAyEA;EACE,WAAA;EACA,mBAAA;EACA,gCAAA;AAtEF;;AAyEA;EACE,WAAA;AAtEF;;AAyEA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AAtEJ;;AAyEA;EACE,yBAAA;AAtEF;;AAyEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAtEF;;AAyEA;EACE,WAAA;AAtEF","sourcesContent":[".model-box {\n  width: 100%;\n  background: #fff;\n\n  ion-title {\n    background: #fff;\n    padding: 0 3px;\n    font-size: 16px;\n  }\n\n  .img-box {\n    width: 100%;\n    //height: 120px;\n    max-height: 120px;\n    vertical-align: middle;\n    display: table;\n  }\n\n  .img-box app-img {\n    vertical-align: middle;\n    display: table-cell;\n    width: 100%;\n  }\n}\n\n.noStyle {\n  ion-card {\n    margin: 0;\n  }\n}\n\n\n.title {\n  min-height: 36px;\n  max-height: 36px;\n  font-weight: bold;\n  text-align: center;\n  width: 100%;\n}\n\n.relative .name-box {\n  line-height: 1;\n  //font-size: 18px;\n  padding: 2px 0;\n  //color: var(--element-color)\n}\n\n.name-box {\n  text-shadow: 0px 0px 10px #ccc;\n  //  tmp tmp tmp tmp TODO\n  color: black;\n}\n\n.toolbar-row {\n  display: flex;\n  overflow-x: auto;\n\n  .toolbar-item {\n    //padding: 10px 24px;\n    flex: 0 0 auto;\n    cursor: pointer;\n    color: var(--main-button-backgroud);\n  }\n\n  .toolbar-item + .toolbar-item {\n    border-right: solid 1px #ccc;\n  }\n\n  .toolbar-item:active, .toolbar-item:hover {\n    filter: brightness(80%);\n    background: var(--button-a-background);\n    color: var(--main-top-text);\n  }\n\n  .toolbar-item.active {\n    //background:brightness(80%);\n  }\n\n}\n\n.toolbar-row::-webkit-scrollbar {\n  display: none;\n}\n\n.active {\n  filter: brightness(80%);\n  background: var(--button-a-background);\n  color: var(--main-top-text);\n}\n\n.scroll-box {\n  //margin: 0 4px;\n\n\n  //.arrow-segment\n  //{\n  //  ion-segment {\n  //    width: 40px;\n  //  }\n  //}\n  //\n  //.main-segment\n  //{\n  //  ion-segment {\n  //    width: fit-content;\n  //  }\n  //}\n}\n\n//background: #ccc;\n//width: 100%;\n//height: 40px;\n//margin-top: 4px;\n//line-height: 1;\n//display: table;\n\n//.name-box\n//{\n//  //vertical-align: middle;\n//  //display: table-cell;\n//}\n//}\n\n\n@media screen and (min-width: 767px) {\n  .model-box {\n    .img-box {\n      width: 100%;\n      height: 200px;\n      //max-height: 200px;\n      vertical-align: middle;\n      display: table;\n    }\n  }\n\n}\n\n\n.fields-slider{\n\n\n  //.swiper-wrapper{\n  //  gap: 1px;\n  //  background: #ccc;\n  //}\n\n  ion-slide{\n    height: 40px;\n    background: white;\n    border-left: 1px solid #ccc;\n  }\n  ion-slide:hover{\n    filter: brightness(95%);\n    cursor: pointer;\n  }\n}\n\n\n\n.models-swiper {\n  width: 100%;\n  background: #ececec;\n  border-bottom: 1px solid #ececec;\n}\n\n.model-slide {\n  width: auto;\n}\n\n.model-card {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    background: #fff;\n    white-space: nowrap;\n    transition: background 0.2s;\n    font-size: 14px;\n    min-height: 40px;\n    padding: 0 10px;\n    cursor: pointer;\n}\n\n.model-card:hover {\n  background-color: #f5f5f5;\n}\n\n.model-img {\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  object-fit: cover;\n}\n\n.model-name {\n  color: #333;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
